const WinHistory = () => {
  return (
    <div>
      <h1>Win History</h1>
    </div>
  );
};

export default WinHistory;
